import {Asset} from '../Assets.types';
import {DerivedFilePurpose} from '../Assets.enums';

/**
 * Returns a derived file URL for an asset (fallback to original).
 */
export default function getDerivedFileUrl(
  asset: Asset,
  derivedFilePurpose: DerivedFilePurpose,
): string {
  const originalUrl = asset.originalfile.fileUrl || '';

  const derivedFile = asset.derivedFiles.find(
    (file) => file.derivedFilePurpose === derivedFilePurpose,
  );

  return derivedFile?.technicalMetadata?.fileUrl || originalUrl;
}
